/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in session storage */
  static #STORAGE_KEY = 'viewedProducts';
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 4;

  static #getStorageKey() {
    const context = window.OffhooRecentlyViewedContext;

    if (!context?.enabled || !context.customerId) {
      return null;
    }

    const shop = context.shop || window.location.hostname;

    return `${this.#STORAGE_KEY}:${shop}:${context.customerId}`;
  }

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   */
  static addProduct(productId) {
    const storageKey = this.#getStorageKey();

    if (!storageKey) return;

    let viewedProducts = this.getProducts();

    viewedProducts = viewedProducts.filter((/** @type {string} */ id) => id !== productId);
    viewedProducts.unshift(productId);
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    localStorage.setItem(storageKey, JSON.stringify(viewedProducts));
  }

  static clearProducts() {
    const storageKey = this.#getStorageKey();

    if (!storageKey) return;

    localStorage.removeItem(storageKey);
  }

  /**
   * Retrieves the list of recently viewed products from session storage.
   * @returns {string[]} The list of viewed products.
   */
  static getProducts() {
    const storageKey = this.#getStorageKey();

    if (!storageKey) return [];

    return JSON.parse(localStorage.getItem(storageKey) || '[]');
  }
}
